import React, { useContext } from "react";
import clsx from "clsx";
import { Link } from "react-router-dom";

import {
  Context,
  activeLearningTextbookPath,
  activeLearningStoryBookPath,
} from "../../../teacherStore";
import { parseQueryParams } from "../../../libs/Util";
import ThemeCard from "../../../organisms/ActiveLearning/ThemeCard";
import ThemeModal from "../../../organisms/ActiveLearning/ThemeModal";
import notFoundImg from "../../../assets/images/ActiveLearning/not_found_theme.jpg";

import styles from "./ActiveLearningThemes.module.scss";

export const ActiveLearningThemes = () => {
  const { state } = useContext(Context);
  const classListInParams = parseQueryParams()["classList"];
  const codeInParams = parseQueryParams()["code"];

  const [themeModal, setThemeModal] = React.useState<{
    isShow: boolean;
    id: number;
  }>({
    isShow: false,
    id: 0,
  });

  return (
    <div className={styles.wrapper} id="accordion">
      {themeModal.isShow && (
        <ThemeModal
          isTeacherSide={true}
          videoDomain={process.env.REACT_APP_TEACHER_DLP_URL}
          activeLearningThemes={state.active_learning_themes}
          activeLearningStoryBookPath={activeLearningStoryBookPath}
          handleClose={() => setThemeModal({ ...themeModal, isShow: false })}
          themeId={themeModal.id}
          hideActionButton
        />
      )}
      <Link
        className={styles.returnLink}
        to={`${activeLearningTextbookPath}?classList=${classListInParams}&code=${codeInParams}`}
      >
        く教材選択に戻る
      </Link>
      <div className={clsx(styles.themeCardList, styles.isPc)}>
        {state.active_learning_themes.map(theme => {
          const no = String(theme.display_order).padStart(2, "0");
          return (
            <ThemeCard
              key={theme.id}
              no={String(no)}
              title={theme.title}
              desc={theme.desc}
              imageUrl={
                theme.enageed_theme_name
                  ? `https://admin.gear.enageed.net${theme.image_url}`
                  : notFoundImg
              }
              width={"calc((100% - 16px * 2) / 3)"}
              backgroundColor={"#fff"}
              handleDetail={() => setThemeModal({ isShow: true, id: theme.id })}
              hideActionButton
            />
          );
        })}
      </div>
      <div className={clsx(styles.themeCardList, styles.isSp)}>
        {state.active_learning_themes.map(theme => {
          const no = String(theme.display_order).padStart(2, "0");
          return (
            <ThemeCard
              key={theme.id}
              no={String(no)}
              title={theme.title}
              desc={theme.desc}
              imageUrl={
                theme.enageed_theme_name
                  ? `https://admin.gear.enageed.net${theme.image_url}`
                  : notFoundImg
              }
              width={"100%"}
              backgroundColor={"#fff"}
              handleDetail={() => setThemeModal({ isShow: true, id: theme.id })}
              hideActionButton
            />
          );
        })}
      </div>
    </div>
  );
};

export default ActiveLearningThemes;
